"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDITIONAL_GDPR_COUNTRIES = exports.EU_COUNTRY_CODES = exports.COUNTRY_CODES = void 0;

/**
 * Country constants
 * ISO 2-Letter Country Codes - https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 */

/**
 * Country Codes
 * @type {Object}
 */
const COUNTRY_CODES = {
  Australia: 'AU',
  Brazil: 'BR',
  Canada: 'CA',
  China: 'CN',
  CzechRepublic: 'CZ',
  Denmark: 'DK',
  France: 'FR',
  Germany: 'DE',
  India: 'IN',
  Indonesia: 'ID',
  Israel: 'IL',
  Italy: 'IT',
  Japan: 'JP',
  Korea: 'KR',
  LatinAmerica: 'LA',
  Malaysia: 'MY',
  Netherlands: 'NL',
  Norway: 'NO',
  Poland: 'PL',
  Portugal: 'PT',
  Russia: 'RU',
  SouthAfrica: 'ZA',
  Spain: 'ES',
  Sweden: 'SE',
  Thailand: 'TH',
  UnitedKingdom: 'GB',
  UnitedStates: 'US',
  Vietnam: 'VN'
};
/**
 * European Country Codes
 * @type {String[]}
 */

exports.COUNTRY_CODES = COUNTRY_CODES;
const EU_COUNTRY_CODES = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
/**
 * Additional Countries that are
 * not part of the EU, but we need
 * display Cookie Consent for
 * @type {String[]}
 */

exports.EU_COUNTRY_CODES = EU_COUNTRY_CODES;
const ADDITIONAL_GDPR_COUNTRIES = ['IS', // Iceland
'LI', // Liechtenstein
'NO', // Norway
'RU' // Russia
];
exports.ADDITIONAL_GDPR_COUNTRIES = ADDITIONAL_GDPR_COUNTRIES;